import React from "react";
import "./ProductSectionButton.scss";
import { useDispatch } from "react-redux";
import { useCartContext } from "../../../lib/CartContext/CartContext";
import { addIdToCart } from "../../../actions/cartActions";

const ProductSectionButton = (props) => {
  const {
    productAttributes: { id = 0, quantity = 1 },
  } = props;
  const dispatch = useDispatch();
  const cartContext = useCartContext();

  const handleCartUpdate = (e) => {
    e.preventDefault();
    cartContext.addProduct(id, quantity, null);
    dispatch(addIdToCart(id));
    props.updateStatus();
  };

  return (
    <button
      onClick={(e) => handleCartUpdate(e)}
      className={
        "ProductSectionButton ProductSectionButton--" + props.buttonClass
      }
    >
      {props.title}
    </button>
  );
};

export default ProductSectionButton;
